import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { NotificationEntity, UserRelationsResponse } from '@interpals/api-web';

import api from 'api';

const PAGE_LIMIT = 10;

interface NotificationResponse {
    data: NotificationEntity[];
    hasMore: boolean;
    offset: number;
}

export const getNotifications = createAsyncThunk<NotificationResponse, { offset: number }>(
    'get/notifications',
    async ({ offset }) => {
        const response = await api.getMyNotification({ limit: PAGE_LIMIT, offset });

        return { data: response.data, hasMore: response.data.length === PAGE_LIMIT } as NotificationResponse;
    },
);

export const markNotificationsRead = createAsyncThunk('set/notifications-read', async () => {
    await api.markAllNotificationsRead();
});

export const markViewsRead = createAsyncThunk<void, string>('set/notifications-views-read', async (accountId) => {
    await api.resetViewsById({ id: accountId });
});

export const getFriendRequests = createAsyncThunk<UserRelationsResponse, void>('get/friend-requests', async () => {
    return await api.getRelationByType({
        id: 'self',
        type: 'incoming',
        offset: 0,
        extra: 'user.location',
    });
});

export const setNotificationsLastFetched = createAction<number | undefined>('set/notifications-last-fetched');
